/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */
/* eslint-disable max-statements */
/* eslint-disable max-lines */

import cloneDeep from 'lodash/cloneDeep';
import Mustache from 'mustache';

import { fplsConstants } from './constants';
import win from './win';
import { htmlToPlainText, visiblePages } from './utils';
import { applyLogic, isTriggerField } from './logic_utils';
import { SUBMIT_BUTTON_ID } from '../components/builder/components/modals/logic-config/utils';

export const ControlType = {
  // v6.1 Renamed components
  SHORT_TEXT: 'short_text',
  LABELED_INPUT: 'labeled_input',
  EMAIL: 'email',
  WEBSITE: 'website',
  NUMBER: 'number_input',
  DATETIME: 'datetime',
  PHONE: 'phone',
  // select
  SELECT_BASIC: 'select_basic',
  SELECT_MULTIPLE: 'select_multiple',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  // file upload
  FILE_UPLOAD: 'file_upload',
  // MEDIA
  MEDIA_HEADER: 'media_header',
  MEDIA_IMAGE: 'media_image',

  // Legacy fallbacks
  // inputs
  TEXT_INPUT: 'text_input',
  PREPENDED_TEXT: 'prepended_text',
  APPENDED_TEXT: 'appended_text',
  TEXT_AREA: 'text_area',
  SIGNATURE: 'signature',
  // checkbox/radio
  CHECKBOXES: 'checkboxes',
  // ^used checkbox: someone didn't get the legacy memo.
  RADIO_BUTTONS: 'radio_buttons', // <the radio, ditto.
  INLINE_CHECKBOXES: 'inline_checkboxes',
  INLINE_RADIOS: 'inline_radios',
  IMAGE_CHOICE: 'image_choice',
  // structure
  DESCRIPTION: 'description',
  EMBED_FIELD: 'embed_field',
  STAR_RATING: 'star_rating',
  HEART_RATING: 'heart_rating',
  SCALE_RATING: 'scale_rating',
  MATRIX_RATING: 'matrix_rating',
  SMILEY_RATING: 'smiley_rating',
  ROW: 'add_row',
  TABLE_FIELD: 'table_field',
  LOOKUP: 'lookup',
  DURATION: 'duration',
  PAYPAL: 'paypal',
  STRIPE: 'stripe',
  FLUTTERWAVE: 'flutterwave',
  PAYSTACK: 'paystack',
  OptOther: {
    STRING: '__fpls_opt_other__',
  },
  COUNTRY: 'country',
  ADDRESS: 'address',
  RANKING: 'ranking',
  INVENTORY: 'inventory_field',
};

const PaymentTypes = [ControlType.PAYPAL, ControlType.PAYSTACK, ControlType.FLUTTERWAVE, ControlType.STRIPE];

const OfflineRestrictedTypes = [...PaymentTypes, ControlType.SIGNATURE, ControlType.FILE_UPLOAD];

export const fieldsWithTextAsLabel = [ControlType.DESCRIPTION, ControlType.MEDIA_HEADER];

export const InputType = {
  TEXT: 0,
  EMAIL: 1,
  NUMBER: 2,
};

export const DateTimeType = {
  DATETIME: 0,
  DATE: 1,
  TIME: 2,
};

export const multiSelectControls = [
  ControlType.SELECT_MULTIPLE,
  ControlType.CHECKBOXES
]

const OriginType = { NEW: 1, TEMPLATE: 2, EDIT: 3 };

const UploadCategoryType = {
  IMAGES: 0,
  VIDEOS: 1,
  DOCUMENTS: 2,
};

const OptOther = {
  STRING: '__fpls_opt_other__',
};

export function allowedFilterConditionTypes() {
  const emptyConds = ['empty', 'not_empty'];
  const emptyAndEqualConds = ['equal', 'not_equal', ...emptyConds];
  const containsConds = ['contain', 'not_contain', 'starts_with', 'ends_with'];
  const greaterLesserConds = ['greater_than', 'greater_than_equal', 'less_than', 'less_than_equal'];
  const emptyAndEqualsAndContainsConds = [...emptyAndEqualConds, ...containsConds];
  const allConds = [...emptyAndEqualConds, ...containsConds, ...greaterLesserConds];

  const acTypes = {};
  acTypes[ControlType.NUMBER] = allConds;
  acTypes[ControlType.DURATION] = allConds;
  acTypes[ControlType.CHECKBOXES] = emptyAndEqualConds;
  acTypes[ControlType.CHECKBOX] = emptyAndEqualConds;
  acTypes[ControlType.INLINE_RADIOS] = emptyAndEqualConds;
  acTypes[ControlType.INLINE_CHECKBOXES] = emptyAndEqualConds;
  acTypes[ControlType.RADIO_BUTTONS] = emptyAndEqualConds;
  acTypes[ControlType.RADIO] = emptyAndEqualConds;
  acTypes[ControlType.SELECT_BASIC] = emptyAndEqualConds;
  acTypes[ControlType.SCALE_RATING] = emptyAndEqualConds;
  acTypes[ControlType.SMILEY_RATING] = emptyAndEqualConds;
  acTypes[ControlType.STAR_RATING] = emptyAndEqualConds;
  acTypes[ControlType.IMAGE_CHOICE] = emptyAndEqualConds;
  acTypes[ControlType.HEART_RATING] = emptyAndEqualConds;
  acTypes[ControlType.SELECT_MULTIPLE] = emptyAndEqualConds;
  acTypes[ControlType.COUNTRY] = emptyAndEqualConds;
  acTypes[ControlType.TABLE_FIELD] = emptyConds;

  acTypes[ControlType.APPENDED_TEXT] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.EMAIL] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.WEBSITE] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.LABELED_INPUT] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.PHONE] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.PREPENDED_TEXT] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.SHORT_TEXT] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.TEXT_INPUT] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.TEXT_AREA] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.LOOKUP] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.MATRIX_RATING] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.FILE_UPLOAD] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.SIGNATURE] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.PAYPAL] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.STRIPE] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.FLUTTERWAVE] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.PAYSTACK] = emptyAndEqualsAndContainsConds;
  acTypes[ControlType.DATETIME] = emptyAndEqualsAndContainsConds;

  acTypes.timeType = [...emptyAndEqualConds, ...greaterLesserConds];
  return acTypes;
}

export const getUnpipedLabel = (label) => {
  if (!label) return label;
  const pipedIdPattern = /\{[^}]+\}/g;
  return label.replaceAll(pipedIdPattern, '');
};

export function ctrlDefaults(builder) {
  const defs = {
    title: 'Click to Edit Form Title',
    subtext: 'Click to edit help text',
    placeholder: 'Click to edit placeholder text',
  };
  // if (!builder) {
  //   defs[ControlType.SHORT_TEXT] = '';
  //   defs[ControlType.LABELED_INPUT] = '';
  //   defs[ControlType.EMAIL] = '';
  //   defs[ControlType.WEBSITE] = '';
  //   defs[ControlType.NUMBER] = '';
  //   defs[ControlType.DATETIME] = '';
  //   defs[ControlType.PHONE] = '';
  //   defs[ControlType.SELECT_BASIC] = '';
  //   defs[ControlType.SELECT_MULTIPLE] = '';
  //   defs[ControlType.CHECKBOX] = '';
  //   defs[ControlType.RADIO] = '';
  //   defs[ControlType.FILE_UPLOAD] = '';
  //   defs[ControlType.TEXT_INPUT] = '';
  //   defs[ControlType.PREPENDED_TEXT] = '';
  //   defs[ControlType.APPENDED_TEXT] = '';
  //   defs[ControlType.TABLE_FIELD] = '';
  //   defs[ControlType.TEXT_AREA] = '';
  //   defs[ControlType.SIGNATURE] = '';
  //   defs[ControlType.CHECKBOXES] = '';
  //   defs[ControlType.RADIO_BUTTONS] = '';
  //   defs[ControlType.INLINE_CHECKBOXES] = '';
  //   defs[ControlType.INLINE_RADIOS] = '';
  //   defs[ControlType.IMAGE_CHOICE] = '';
  //   defs[ControlType.STAR_RATING] = '';
  //   defs[ControlType.SCALE_RATING] = '';
  //   defs[ControlType.HEART_RATING] = '';
  //   defs[ControlType.MATRIX_RATING] = '';
  //   defs[ControlType.SMILEY_RATING] = '';
  //   defs[ControlType.LOOKUP] = '';
  //   defs[ControlType.DURATION] = '';
  //   defs[ControlType.PAYPAL] = '';
  //   defs[ControlType.STRIPE] = '';
  //   defs[ControlType.FLUTTERWAVE] = '';
  //   defs[ControlType.PAYSTACK] = '';
  //   defs[ControlType.COUNTRY] = '';
  //   defs[ControlType.ADDRESS] = '';
  //   defs[ControlType.RANKING] = '';
  //   defs.title = '';
  //   defs.subtext = '';
  //   defs.options = '';
  //   defs.placeholder = '';
  // } else {
  defs[ControlType.SHORT_TEXT] = 'Short Text';
  defs[ControlType.LABELED_INPUT] = 'Labeled Input';
  defs[ControlType.EMAIL] = 'Email';
  defs[ControlType.WEBSITE] = 'Website';
  defs[ControlType.NUMBER] = 'Number';
  defs[ControlType.DATETIME] = 'Date and Time';
  defs[ControlType.PHONE] = 'Phone Number';
  defs[ControlType.SELECT_BASIC] = 'Single Select';
  defs[ControlType.SELECT_MULTIPLE] = 'Multiple Select';
  defs[ControlType.CHECKBOX] = 'Checkboxes';
  defs[ControlType.RADIO] = 'Radio Buttons';
  defs[ControlType.FILE_UPLOAD] = 'Upload File';
  defs[ControlType.TEXT_INPUT] = 'Short Text';
  defs[ControlType.SIGNATURE] = 'Signature';
  defs[ControlType.PREPENDED_TEXT] = 'Labeled Input';
  defs[ControlType.APPENDED_TEXT] = 'Labeled Input';
  defs[ControlType.TABLE_FIELD] = 'Table';
  defs[ControlType.TEXT_AREA] = 'Long Text';
  defs[ControlType.CHECKBOXES] = 'Checkboxes';
  defs[ControlType.RADIO_BUTTONS] = 'Radio Buttons';
  defs[ControlType.INLINE_CHECKBOXES] = 'Checkboxes';
  defs[ControlType.IMAGE_CHOICE] = 'Image Choice';
  defs[ControlType.INLINE_RADIOS] = 'Radio Buttons';
  defs[ControlType.STAR_RATING] = 'Star Rating';
  defs[ControlType.SCALE_RATING] = 'Scale Rating';
  defs[ControlType.HEART_RATING] = 'Heart Rating';
  defs[ControlType.MATRIX_RATING] = 'Matrix Rating';
  defs[ControlType.SMILEY_RATING] = 'Smiley Rating';
  defs[ControlType.PAYPAL] = 'Paypal';
  defs[ControlType.STRIPE] = 'Stripe';
  defs[ControlType.FLUTTERWAVE] = 'Flutterwave';
  defs[ControlType.PAYSTACK] = 'Paystack';
  defs[ControlType.LOOKUP] = 'Lookup';
  defs[ControlType.DURATION] = 'Duration';
  defs[ControlType.DESCRIPTION] = 'Description';
  defs[ControlType.EMBED_FIELD] = 'Embed field';
  defs[ControlType.MEDIA_HEADER] = 'Media Header';
  defs[ControlType.MEDIA_IMAGE] = 'Media IMAGE';
  defs[ControlType.COUNTRY] = 'Country';
  defs[ControlType.ADDRESS] = 'Address';
  defs[ControlType.RANKING] = 'Ranking';
  defs[ControlType.INVENTORY] = 'Inventory';
  // }
  return defs;
}

export function toHex(str) {
  let hex = str;
  if (str && str.charAt(0) !== '#') {
    hex = `#${str}`;
  }
  return hex;
}

const internalIdentifiers = {};
const displayIdentifiers = {};

export const getLabel = (propertyName, customText) => customText[propertyName];

export const defaultUserCustomTexts = {
  id: null,
  collect_email_text: 'Please provide your email',
  upload_file: 'Click to upload file',
  select_option: 'Select Option',
  filter_label: 'Filter',
  add_new_row: 'Add New Row',
  accept: 'Accept',
  resets: 'Reset',
  next_page: 'Next Page',
  previous_page: 'Previous',
  print_response_text: 'Print submitted response',
  submit_another_response: 'Submit another response',
  continue_text: 'Continue',
  submit_text: 'Submit',
  edit_submit_text: 'Update Response',
  done: 'Done',
  select_all: 'Select All',
  select_none: 'Select None',
  edit_response: 'Edit your response',
  copy_edit_link_text: 'Copy edit link',
  deadline_error: 'Deadline for responses has passed.',
  response_exceeded: 'Maximum number of submissions has been reached',
  edit_link_expired: 'This edit link has expired',
  required_field: 'Value for this field is required',
  invalid_email: 'Provided text is not a valid email.',
  invalid_number: 'Provided text is not a number',
  invalid_website: 'Please enter a valid website address. It should start with http://, https://, or www.',
  invalid_phone_no: 'Provided text is not a valid phone number.',
  min_characters: 'Please enter at least {{ minimum }} characters.',
  max_characters: 'Please enter no more than {{ maximum }} characters.',
  min_selects: 'Please select at least {{ minimum }} options. {{ number }} selected.',
  max_selects: 'Please select at most {{ maximum }} options. {{ number }} selected.',
  min_words: 'Please enter at least {{ minimum }} words.',
  max_words: 'Please enter no more than {{ maximum }} words.',
  signature_upload_error: 'Signature Upload is in progress',
  signature_acceptance_error: 'Signatures drawn should be accepted or reset',
  signature_progress_error: 'An error occurred while trying to upload signature, please try again',
  upload_size_error: 'Maximum file size allowed is ',
  file_error: 'Allowed files are ',
  captcha_error: 'Please resolve the captcha before submitting the form.',
  resolve_captcha: 'Resolve captcha',
  incomplete_form: 'Incomplete form',
  form_submission_error: 'Form submission error',
  empty_form: "You can't save an empty form. Please fill the form fields and then submit.",
  submit_error: 'Error has occurred when submitting form',
  required_provided_error: 'Please provide data for all required fields and correct already provided values',
  required_error: 'Please provide data for all required fields',
  provided_error: 'Please correct provided data',
  loading_error: 'Error loading form',
  post_submit_error: 'Error submitting form',
  more_post_submit_error:
    'We are sorry but there was an issue while submitting this form. Please click the button below  to view the form and retry using your previous data.  You may also reload the form and try again.',
  save_form_progres: 'Save Form Progress',
  email_for_link: 'Give your email to get a link to continue filling your form later.',
  use_saveandContinue_link: 'Use the link below to continue form submission at any time.',
  upload_in_progress: 'Uploads in progress',
  wait_for_upload: 'Form submission will be possible when uploaded files are done',
  loading_form: 'Loading form',
  wait_for_submit: 'Submitting form. Please wait',
  email_for_saved: 'An email has also been sent to you containing the link.',
  pages_left: 'page(s) left',
  continue_to_form: 'Continue to form',
  view_intro_page: 'View intro page',
  start_form: 'Start',
};

export function shouldRender(ctrl, plan, hiddenFields) {
  if (ctrl.props.hidden) return false;
  if (ctrl.is_row) return false;
  if (hiddenFields && hiddenFields[ctrl.internal_id]) return false;
  if (ctrl.props.is_inventory_payment) return false;
  // TODO: Fix plan.has_payment
  // if (!plan.has_payment && payfields.indexOf(ctrl.type) > -1) {
  //   render = false;
  // }
  // if (ctrl.type === 'lookup' && !plan.has_lookup) {
  //   render = false;
  // }
  return true;
}

export function shouldRenderOnPaymentModal(ctrl, plan, hiddenFields) {
  const paymentControlTypes = ['stripe', 'flutterwave', 'paypal', 'paystack'];
  if (hiddenFields && hiddenFields[ctrl.internal_id]) return false;
  if (!paymentControlTypes.includes(ctrl.type)) return false;
  if (!ctrl.props.is_inventory_payment) return false;
  if (ctrl.props.hidden) return false;
  if (ctrl.is_row) return false;
  return true;
}

export function shouldRenderFieldInRow(rowCtrlId, hiddenFields) {
  if (hiddenFields && hiddenFields[rowCtrlId]) return false;
  return true;
}

export const answerPipingSupportedControls = [
  ControlType.INLINE_CHECKBOXES,
  ControlType.SELECT_MULTIPLE,
  ControlType.LABELED_INPUT,
  ControlType.SMILEY_RATING,
  ControlType.INLINE_RADIOS,
  ControlType.RADIO_BUTTONS,
  ControlType.MATRIX_RATING,
  ControlType.SCALE_RATING,
  ControlType.IMAGE_CHOICE,
  ControlType.SELECT_BASIC,
  ControlType.MEDIA_HEADER,
  ControlType.HEART_RATING,
  ControlType.STAR_RATING,
  ControlType.DESCRIPTION,
  ControlType.FILE_UPLOAD,
  ControlType.FLUTTERWAVE,
  ControlType.SHORT_TEXT,
  ControlType.TEXT_INPUT,
  ControlType.CHECKBOXES,
  ControlType.TEXT_AREA,
  ControlType.INVENTORY,
  ControlType.SIGNATURE,
  ControlType.CHECKBOX,
  ControlType.DATETIME,
  ControlType.PAYSTACK,
  ControlType.COUNTRY,
  ControlType.RANKING,
  ControlType.WEBSITE,
  ControlType.ADDRESS,
  ControlType.PAYPAL,
  ControlType.STRIPE,
  ControlType.LOOKUP,
  ControlType.PHONE,
  ControlType.RADIO,
  ControlType.EMAIL
];

export const answerPipeableControlTypes = [
  ControlType.PREPENDED_TEXT,
  ControlType.APPENDED_TEXT,
  ControlType.INLINE_RADIOS,
  ControlType.RADIO_BUTTONS,
  ControlType.LABELED_INPUT,
  ControlType.SELECT_BASIC,
  ControlType.SHORT_TEXT,
  ControlType.TEXT_INPUT,
  ControlType.DATETIME,
  ControlType.COUNTRY,
  ControlType.NUMBER,
  ControlType.PHONE,
  ControlType.RADIO,
  ControlType.EMAIL
];

const elements = {
  [ControlType.MEDIA_HEADER]: {
    piped_label: 'Section Header',
    enable_answer_piping: false,
    text: 'Section Header',
    text_alignment: 'left',
    divider: false,
  },
  [ControlType.MEDIA_IMAGE]: {
    image_url: '/static/images/external/overview-small.png',
    upload_image: '',
    placement: 'center',
  },
  [ControlType.LABELED_INPUT]: {
    enable_answer_piping: false,
    piped_label: 'Labeled Input',
    label: 'Labeled Input',
    placeholder: '',
    subtext: '',
    appended_text: '',
    prepended_text: '',
    type: InputType.TEXT,
    default: '',
    required: false,
    // Position of label
    left: true,
    right: false,
    hidden: false,
    readonly: false,
    operation: '',
    column_calculation: 0,
    min_length: null,
    max_length: null,
    min_count: null,
    max_count: null,
    min_acceptable: null,
    max_acceptable: null,
  },
  // inputs
  [ControlType.TEXT_INPUT]: {
    enable_answer_piping: false,
    piped_label: 'Short Text',
    label: 'Short Text',
    placeholder: '',
    subtext: '',
    type: InputType.TEXT,
    default: '',
    required: false,
    hidden: false,
    readonly: false,
    operation: '',
    column_calculation: 0,
    min_length: null,
    max_length: null,
    min_count: null,
    max_count: null,
    min_acceptable: null,
    max_acceptable: null,
  },
  [ControlType.SHORT_TEXT]: {
    enable_answer_piping: false,
    piped_label: 'Short Text',
    label: 'Short Text',
    placeholder: '',
    subtext: '',
    default: '',
    required: false,
    hidden: false,
    readonly: false,
    type: InputType.TEXT,
    min_length: null,
    max_length: null,
    min_count: null,
    max_count: null,
    min_acceptable: null,
    max_acceptable: null,
  },
  [ControlType.EMAIL]: {
    enable_answer_piping: false,
    piped_label: 'Email',
    label: 'Email',
    placeholder: '',
    subtext: '',
    default: '',
    required: false,
    hidden: false,
    readonly: false,
  },
  [ControlType.WEBSITE]: {
    enable_answer_piping: false,
    piped_label: 'Website',
    label: 'Website',
    placeholder: '',
    subtext: '',
    default: '',
    required: false,
    hidden: false,
    readonly: false,
  },
  [ControlType.NUMBER]: {
    label: 'Number',
    placeholder: '',
    subtext: '',
    default: '',
    required: false,
    hidden: false,
    readonly: false,
    operation: '',
    column_calculation: 0,
    min_count: null,
    max_count: null,
    min_acceptable: null,
    max_acceptable: null,
  },
  [ControlType.PREPENDED_TEXT]: {
    label: '',
    prepended_text: 'some text',
    placeholder: '',
    subtext: '',
    default: '',
    required: false,
    type: InputType.TEXT,
    hidden: false,
    readonly: false,
    column_calculation: 0,
    min_length: null,
    max_length: null,
    min_count: null,
    max_count: null,
    min_acceptable: null,
    max_acceptable: null,
  },
  [ControlType.APPENDED_TEXT]: {
    label: '',
    appended_text: 'some text',
    placeholder: '',
    subtext: '',
    default: '',
    required: false,
    type: InputType.TEXT,
    hidden: false,
    readonly: false,
    column_calculation: 0,
    min_length: null,
    max_length: null,
    min_count: null,
    max_count: null,
    min_acceptable: null,
    max_acceptable: null,
  },
  [ControlType.TEXT_AREA]: {
    enable_answer_piping: false,
    piped_label: 'Long Text',
    label: 'Long Text',
    placeholder: '',
    subtext: '',
    default: '',
    required: false,
    hidden: false,
    readonly: false,
    min_length: null,
    max_length: null,
    max_word_length: null,
    min_word_length: null,
  },
  [ControlType.SIGNATURE]: {
    enable_answer_piping: false,
    piped_label: 'Signature',
    label: 'Signature',
    subtext: '',
    required: false,
    rename: { enabled: false, internal_id: '' },
    hidden: false,
    width: 0,
    height: 0,
  },
  [ControlType.DATETIME]: {
    enable_answer_piping: false,
    piped_label: 'Date and Time',
    label: 'Date and Time',
    subtext: '',
    type: DateTimeType.DATETIME,
    min_date: '',
    max_date: '',
    min_time: '',
    max_time: '',
    disable_year: false, // disable year in date
    disabled_days: [], // disable specific week days throughout the calendar e.g all Sundays, Mondays or Tuesdays
    disabled_dates: [], // disable list of specific dates e.g ['2023-04-07', '2024-05-06']
    disabled_date_range: '', // disable dates within a range e.g '2023-04-07 to 2023-04-16'
    time_format: '24',
    separator: '/',
    mode: 'single',
    date_format: 'YYYY/MM/DD',
    past: false,
    future: false,
    default: '',
    now: false,
    required: false,
    hidden: false,
    readonly: false,
  },
  [ControlType.PHONE]: {
    enable_answer_piping: false,
    piped_label: 'Phone Number',
    label: 'Phone Number',
    subtext: '',
    required: false,
    hidden: false,
    readonly: false,
    phone_default_code: 'US',
    phone_codes_limit: false,
    phone_valid_codes: [],
  },
  [ControlType.SELECT_BASIC]: {
    enable_answer_piping: false,
    piped_label: 'Single Select',
    label: 'Single Select',
    subtext: '',
    options: ['One', 'Option', 'Per', 'Line', '(press enter)'],
    option_values: false,
    required: false,
    sort_options: false,
    other: { enabled: false, label: 'Other Text' },
    hidden: false,
    weights: [1, 1, 1, 1, 1],
    operation: '',
    column_calculation: 0,
  },
  [ControlType.SELECT_MULTIPLE]: {
    enable_answer_piping: false,
    piped_label: 'Multiple Select',
    label: 'Multiple Select',
    subtext: '',
    options: ['One', 'Option', 'Per', 'Line', '(press enter)'],
    required: false,
    sort_options: false,
    other: { enabled: false, label: 'Other Text' },
    hidden: false,
    min_selections: null,
    max_selections: null,
  },
  [ControlType.CHECKBOXES]: {
    enable_answer_piping: false,
    piped_label: 'Checkbox',
    label: 'Checkbox',
    subtext: '',
    options: ['Option one', 'Option two'],
    option_values: false,
    required: false,
    inline: false,
    other: { enabled: false, label: 'Other Text' },
    sort_options: false,
    shuffle_options: false,
    hidden: false,
    readonly: false,
    weights: [1, 1],
    operation: '',
    column_calculation: 0,
    min_selections: null,
    max_selections: null,
  },
  [ControlType.RADIO_BUTTONS]: {
    enable_answer_piping: false,
    piped_label: 'Radio',
    label: 'Radio',
    subtext: '',
    options: ['Option one', 'Option two'],
    option_values: false,
    required: false,
    inline: false,
    other: { enabled: false, label: 'Other Text' },
    sort_options: false,
    shuffle_options: false,
    hidden: false,
    readonly: false,
    weights: [1, 1],
    operation: '',
    column_calculation: 0,
  },
  [ControlType.INLINE_CHECKBOXES]: {
    enable_answer_piping: false,
    piped_label: '',
    label: '',
    subtext: '',
    options: ['Option one', 'Option two'],
    option_values: false,
    required: false,
    other: { enabled: false, label: 'Other Text' },
    sort_options: false,
    hidden: false,
    readonly: false,
    weights: [1, 1],
    operation: '',
    column_calculation: 0,
    min_selections: null,
    max_selections: null,
  },
  [ControlType.INLINE_RADIOS]: {
    enable_answer_piping: false,
    piped_label: '',
    label: '',
    subtext: '',
    options: ['Option one', 'Option two'],
    option_values: false,
    required: false,
    sort_options: false,
    hidden: false,
    readonly: false,
    weights: [1, 1],
    operation: '',
    column_calculation: 0,
  },
  [ControlType.IMAGE_CHOICE]: {
    enable_answer_piping: false,
    piped_label: 'Image Choice',
    label: 'Image Choice',
    subtext: '',
    rating_type: 'radio',
    image_size: 'small',
    required: false,
    show_labels: true,
    inline: false,
    shuffle_options: false,
    sort_options: false,
    options: ['Option one', 'Option two'],
    image_url: 'https://storage.googleapis.com/fplsblog/new_image_choice.svg',
    images: ['', ''], // parallel to the options list
    option_values: false,
    weights: [1, 1],
    operation: '',
    column_calculation: 0,
  },
  [ControlType.FILE_UPLOAD]: {
    enable_answer_piping: false,
    piped_label: 'File Upload',
    label: 'File Upload',
    subtext: '',
    required: false,
    rename: { enabled: false, internal_id: '' },
    hidden: false,
    max_file_size: null,
    file_field_id: '',
    file_categories: null,
    file_extensions: null,
  },
  [ControlType.TABLE_FIELD]: {
    label: 'Table',
    subtext: '',
    max_rows: 50,
    min_rows: 1,
    required: false,
    operation: '',
    columns: 3,
    show_row_headers: false,
    row_headers_column_header: 'Test row header title',
    row_headers: ['Row question/title', 'Row question/title'],
    column_headers: ['Column One', 'Column Two', 'Column Three'],
    column_types: ['text_input', 'heart_rating', 'select_basic'],
    column_widths: [0, 0, 0],
    stacked: false,
    unstackable: false,
    no_table_border: false,
    disable_add_row: false,
    table_width: null,
  },
  [ControlType.DESCRIPTION]: {
    enable_answer_piping: false,
    piped_label: '**User Description**. _Add formatting, images links and more to your form_',
    text: '**User Description**. _Add formatting, images links and more to your form_',
  },
  [ControlType.EMBED_FIELD]: {
    url: 'https://www.youtube.com/watch?v=sYovUsfOtJs',
    width: 854,
    height: 480,
  },
  [ControlType.STAR_RATING]: {
    enable_answer_piping: false,
    piped_label: 'Star Rating',
    label: 'Star Rating',
    subtext: '',
    stars_count: 5,
    required: false,
    option_values: false,
    hidden: false,
    readonly: false,
    operation: '',
    column_calculation: 0,
    get weights() {
      return Array(this.stars_count).fill(1);
    },
    get options() {
      return Array.from({ length: this.stars_count }, (_, i) => `Star ${i + 1}`);
    },
  },
  [ControlType.HEART_RATING]: {
    enable_answer_piping: false,
    piped_label: 'Heart Rating',
    label: 'Heart Rating',
    subtext: '',
    hearts_count: 5,
    required: false,
    option_values: false,
    hidden: false,
    readonly: false,
    operation: '',
    column_calculation: 0,
    get weights() {
      return Array(this.hearts_count).fill(1);
    },
    get options() {
      return Array.from({ length: this.hearts_count }, (_, i) => `Heart ${i + 1}`);
    },
  },
  [ControlType.SCALE_RATING]: {
    enable_answer_piping: false,
    piped_label: 'Scale Rating',
    label: 'Scale Rating',
    options: ['Label One', 'Label Two'],
    subtext: '',
    scale_count: 3,
    required: false,
    option_values: false,
    show_numbers: false,
    inline: true,
    hidden: false,
    readonly: false, 
    operation: '',
    column_calculation: 0,
    get weights() {
      return Array(this.scale_count).fill(1);
    },
    get scale_options() {
      return Array.from({ length: this.scale_count }, (_, i) => `Option ${i + 1}`);
    },
  },
  [ControlType.MATRIX_RATING]: {
    piped_label: 'Share your feedback with us',
    label: 'Share your feedback with us',
    enable_answer_piping: false,
    row_headers: [
      'How satisfied were you with the sessions?',
      'How would you rate the reception?',
      'How do you feel about day one?',
    ],
    column_headers: ['Very Satisfied', 'Satisfied', 'Unsatisfied'],
    option_values: false,
    weights: [1, 1, 1],
    rating_type: 'radio',
    required: false,
    hidden: false,
    columns: 3,
    stacked: false,
    unstackable: false,
    no_table_border: false,
  },
  [ControlType.SMILEY_RATING]: {
    piped_label: 'Tell us how you feel',
    label: 'Tell us how you feel',
    enable_answer_piping: false,
    subtext: '',
    required: false,
    hidden: false,
  },
  [ControlType.ROW]: {
    controls: [],
  },
  [ControlType.PAYPAL]: {
    is_inventory_payment: false,
    enable_answer_piping: false,
    piped_label: 'Paypal',
    label: 'Paypal',
    subtext: '',
    amount: 1,
    currency: 'USD',
    required: false,
    operation: '',
  },
  [ControlType.STRIPE]: {
    is_inventory_payment: false,
    enable_answer_piping: false,
    piped_label: 'Stripe',
    label: 'Stripe',
    subtext: '',
    amount: 1, // price specified by form owner
    user_specify: false, // allow form filler specify amount to pay in form
    currency: 'USD',
    required: false,
    pay_button_text: 'Pay with Card',
    popup_title: 'Pay with Stripe',
    country: '',
    sub_unit: 100,
    list_products: false,
    shown_product: '',
    payment_logo: 'https://stripe.com/img/documentation/checkout/marketplace.png',
    field_type: 'select_basic',
    products: [{ name: 'Placeholder', id: 'placeholder' }],
    billing_address: false,
    save_card_stripe: false,
    metadata: [{ key: '', value: '' }],
    modal_pay_button: 'Pay',
  },
  [ControlType.FLUTTERWAVE]: {
    is_inventory_payment: false,
    enable_answer_piping: false,
    piped_label: 'Flutterwave',
    label: 'Flutterwave',
    subtext: '',
    amount: 500, // price to be paid specified by form owner
    user_specify: false, // allow form filler specify amout to pay in form
    currency: 'NGN',
    required: false,
    pay_button_text: 'Pay Securely',
    popup_title: 'Donate',
    popup_description: 'Money donated goes to charity',
    payment_logo: 'https://ravesandboxapi.flutterwave.com/flwv3-pug/getpaidx/api/pbfui/images/logo.jpg',
    country: 'NG',
    operation: '',
  },
  [ControlType.PAYSTACK]: {
    is_inventory_payment: false,
    enable_answer_piping: false,
    piped_label: 'Paystack',
    label: 'Paystack',
    subtext: '',
    amount: 500, // price to be paid specified by form owner
    user_specify: false, // allow form filler specify amout to pay in form
    currency: 'NGN',
    required: false,
    pay_button_text: 'Pay Now',
    popup_title: 'Donate',
    country: 'NG',
    list_products: false,
    field_type: 'select_basic',
    operation: '',
  },
  [ControlType.LOOKUP]: {
    enable_answer_piping: false,
    lookup_type: 0,
    field_type: 'select_basic',
    piped_label: 'Lookup',
    label: 'Lookup',
    placeholder: '',
    subtext: '',
    default: '',
    form: '',
    form_field: '',
    dest_field_ids: ['init'],
    source_field_ids: ['init'],
    sort: '',
    required: false,
    inline: false,
    options: ['Placeholder', 'Options'],
  },
  [ControlType.DURATION]: {
    label: 'Duration',
    subtext: '',
    unit: 'days',
    default: '',
    required: false,
    hidden: false,
    readonly: false,
  },
  [ControlType.COUNTRY]: {
    enable_answer_piping: false,
    piped_label: 'Country',
    label: 'Country',
    placeholder: 'Select Country',
    subtext: '',
    default: '',
    required: false,
    hidden: false,
    readonly: false,
    country_name: '',
    country_code: '',
  },
  [ControlType.ADDRESS]: {
    enable_answer_piping: false,
    piped_label: 'Address',
    label: 'Address',
    subtext: '',
    required: false,
    hidden: false,
    readonly: false,
    autocomplete: false,
    street_address_line_1: {
      label: 'Street Address Line 1',
      value: '',
      required: true,
      display: true,
      placeholder: '',
    },
    street_address_line_2: {
      label: 'Street Address Line 2',
      value: '',
      required: false,
      display: true,
      placeholder: '',
    },
    postal_code: {
      label: 'Postal Code',
      value: '',
      required: false,
      display: true,
      placeholder: '',
    },
    city: {
      label: 'City/Province',
      value: '',
      required: false,
      display: true,
      placeholder: '',
    },
    state: {
      label: 'State',
      value: '',
      required: false,
      display: true,
      placeholder: '',
    },
    address_country: {
      label: 'Country',
      value: '',
      required: false,
      display: true,
      placeholder: '',
    },
  },
  [ControlType.RANKING]: {
    enable_answer_piping: false,
    piped_label: 'Ranking',
    label: 'Ranking',
    subtext: '',
    required: false,
    hidden: false,
    readonly: false,
    options: ['Option One', 'Option Two'],
    user_option_display: false,
    user_option: 'other',
    other: { enabled: false, label: 'Other Text' },
  },
  [ControlType.INVENTORY]: {
    enable_answer_piping: false,
    piped_label: 'Inventory',
    label: 'Inventory',
    subtext: '',
    required: false,
    hidden: false,
    readonly: false,
    currency: 'USD',
    shuffle_products: false,
    view: 'grid',
    out_of_stock: 'show_label',
    accept_inventory_payment: false,
    inventory_payment_type: '',
    deleted_inventory_product_ids: [],
    inventory_products: [
      {
        product_title: 'Product Name',
        price: 10.0,
        description: '',
        payment_currency: 'USD',
        image: 'https://storage.googleapis.com/fplsblog/shirt_two_s.svg',
        options: {},
        variants: {},
        stock_option: 'flat_stock',
        is_quantity_changed: false,
        category: [],
        enable_stock: false,
        stock_quantity: 0,
      },
      {
        product_title: 'Product Name',
        price: 10.0,
        description: '',
        payment_currency: 'USD',
        image: 'https://storage.googleapis.com/fplsblog/shoe_sub.svg',
        options: {},
        variants: {},
        stock_option: 'flat_stock',
        is_quantity_changed: false,
        category: [],
        enable_stock: false,
        stock_quantity: 0,
      },
    ],
  },
};


const getPipedLabelHTMLString = (label) => `<b style="color: #5972ce">(${label})</b>`;

export const isValidAnswerPipingMustacheTemplate = (template) => {
  const openTags = (template?.match(/{/g) || []).length;
  const closeTags = (template?.match(/}/g) || []).length;
  return openTags === closeTags;
};

export const getPipedLabel = (props) => {
  const { labelPipedCtrlLabelsMap, builderCtrlIds, label } = props;
  Mustache.escape = (value) => value;
  Mustache.tags = ['{', '}'];
  let pipedLabel = label;

  try {
    if (label && isValidAnswerPipingMustacheTemplate(label)) {
      pipedLabel = Mustache.render(label, labelPipedCtrlLabelsMap);
      const matches = label.match(/{\s*[\w\.]+\s*}/g);

      const validCtrlIdMatches = matches?.filter((pipedId) => {
        const ctrlId = pipedId.toString().replace(/[{}]/g, '')?.trim();
        return builderCtrlIds.includes(ctrlId);
      });

      if (validCtrlIdMatches) {
        const uniquePlaceholders = validCtrlIdMatches.map((match, index) => ({
          placeholder: `__PLACEHOLDER_${index}__`,
          original: match
        }));

        uniquePlaceholders.forEach(({ original, placeholder }) => {
          const value = Mustache.render(original, labelPipedCtrlLabelsMap).trim();
          pipedLabel = pipedLabel.replace(value, placeholder);
        });

        uniquePlaceholders.forEach(({ placeholder }) => {
          pipedLabel = pipedLabel.replace(placeholder, getPipedLabelHTMLString(placeholder));
        });

        uniquePlaceholders.forEach(({ placeholder, original }) => {
          const value = Mustache.render(original, labelPipedCtrlLabelsMap).trim();
          const labelPlaceholder = getPipedLabelHTMLString(placeholder);
          const labelValue = getPipedLabelHTMLString(value);

          pipedLabel = pipedLabel.replace(labelPlaceholder, labelValue);
        });
      }
    }
  } catch(error) {
    console.error('Error rendering field label: ', error);
  }

  return pipedLabel;
};

export const getUpdatedBuilderLabelPiping = (props) => {
  const { labelPipedCtrlLabelsMap = {}, builderCtrlIds, editedCtrl, pages } = props;
  const labelProp = fieldsWithTextAsLabel.includes(editedCtrl.type) ? 'text' : 'label';

  const newPipedLabel = getPipedLabel({
    label: editedCtrl.props[labelProp],
    labelPipedCtrlLabelsMap,
    builderCtrlIds
  });
  
  const prevCtrlPipedLabel = labelPipedCtrlLabelsMap?.[editedCtrl.internal_id];
  const newLabelPipedCtrlLabelsMap = labelPipedCtrlLabelsMap;
  const editedCtrlId = editedCtrl.internal_id;
  const ctrlPipedId = `{${editedCtrlId}}`;

  const updatePipedLabel = (label) => label.replaceAll(prevCtrlPipedLabel, newPipedLabel);

  const newPages = cloneDeep(pages).map((page) => Object.fromEntries(
    Object.values(page).map((ctrl) => {
      const ctrlPipedLabel = labelPipedCtrlLabelsMap?.[ctrl.internal_id];
      const { internal_id, table_props, props, type } = ctrl;

      if (type === ControlType.TABLE_FIELD && Array.isArray(ctrlPipedLabel)) {
        table_props.map((tableCtrl, colIndex) => {
          if (tableCtrl?.label?.includes(ctrlPipedId)) {
            const newTableCtrlPipedLabel = updatePipedLabel(ctrlPipedLabel[colIndex]);
            labelPipedCtrlLabelsMap[internal_id][colIndex] = newTableCtrlPipedLabel;
            ctrl.table_props[colIndex].piped_label = newTableCtrlPipedLabel;
          }
        });
      } else {
        const labelProp = fieldsWithTextAsLabel.includes(type) ? 'text' : 'label';
        if (props?.[labelProp]?.includes(ctrlPipedId)) {
          const newCtrlPipedLabel = updatePipedLabel(ctrlPipedLabel);
          labelPipedCtrlLabelsMap[internal_id] = newCtrlPipedLabel;
          ctrl.props.piped_label = newCtrlPipedLabel;
        }
      }

      if (internal_id === editedCtrlId) {
        labelPipedCtrlLabelsMap[internal_id] = newPipedLabel;
        ctrl.props.piped_label = newPipedLabel;
      }

      return [internal_id, ctrl];
    })
  ));
  
  return {
    newLabelPipedCtrlLabelsMap,
    newPages
  };
};

export const unpipeField = (props) => {
  const { labelPipedCtrlLabelsMap, builderCtrlIds, editedCtrl, pages } = props;
  const newLabelPipedCtrlLabelsMap = cloneDeep(labelPipedCtrlLabelsMap);
  const editedCtrlPipedId = `{${editedCtrl.internal_id}}`;
  
  const newPages = cloneDeep(pages).map((page) => Object.fromEntries(
    Object.values(page).map((ctrl) => {
      const { internal_id, props, type } = ctrl;
      if (type === ControlType.TABLE_FIELD) {
        ctrl.table_props = ctrl.table_props.map((colCtrl, colIndex) => {
          if (colCtrl?.enable_answer_piping) {
            const newColumnHeader = ctrl.props.column_headers[colIndex]?.replaceAll(editedCtrlPipedId, '');
            ctrl.props.column_headers[colIndex] = newColumnHeader;

            const newPipedLabel = getPipedLabel({
              labelPipedCtrlLabelsMap,
              label: newColumnHeader,
              builderCtrlIds
            });

            newLabelPipedCtrlLabelsMap[internal_id][colIndex] = newPipedLabel;
            colCtrl.piped_label = newPipedLabel;
          }
          return colCtrl;
        });
      } else if (props?.enable_answer_piping) {
        const labelProp = fieldsWithTextAsLabel.includes(type) ? 'text' : 'label';
        const newLabel = props?.[labelProp]?.replaceAll(editedCtrlPipedId, '');

        const newPipedLabel = getPipedLabel({
          labelPipedCtrlLabelsMap,
          label: newLabel,
          builderCtrlIds,
        });

        newLabelPipedCtrlLabelsMap[internal_id] = newPipedLabel;
        ctrl.props.piped_label = newPipedLabel;
        ctrl.props[labelProp] = newLabel;
      }
      
      return [internal_id, ctrl];
    })
  ));
  
  return {
    newLabelPipedCtrlLabelsMap,
    newPages
  };
};

export const getPipedCtrlLabelsMap = (pages, inCustomise = false) => {
  Mustache.escape = (value) => value;
  Mustache.tags = ['{', '}'];

  if (inCustomise) return pages.reduce((acc, { controls }) => {
    controls.map(({ internal_id, table_props, props, type }) => {
      if (type === ControlType.TABLE_FIELD) {
        const pipedColumnHeaders = table_props.map((tableCtrl) => tableCtrl.piped_label);
        acc[internal_id] = pipedColumnHeaders;
      } else if (answerPipingSupportedControls.includes(type)) {
        acc[internal_id] = props.piped_label;
      }
    });
    return acc;
  }, {});
  
  const ctrlIdValueMap = pages.reduce((acc, { controls }) => {
    controls.map(({ internal_id, value, type }) => {
      if (answerPipeableControlTypes.includes(type)) acc[internal_id] = value;
    });
    return acc;
  }, {});
  
  return pages.reduce((acc, { controls }) => {
    controls.map(({ internal_id, props, type }) => {
      try {
        if (type === ControlType.TABLE_FIELD) {
          const pipedColumnHeaders = props.column_headers.map((header) => (
            Mustache.render(header ?? '', ctrlIdValueMap)
          ));
          acc[internal_id] = pipedColumnHeaders;
        } else {
          if (answerPipingSupportedControls.includes(type)) {
            const label = fieldsWithTextAsLabel.includes(type) ? props.text : props.label;
            const newLabel = Mustache.render(label ?? '', ctrlIdValueMap);
            acc[internal_id] = newLabel;
          }
        }
      } catch(error) {
        console.error('Error rendering field label: ', error);
      }
    });
    return acc;
  }, {});
};

export const getPipedResponseHeader = (header, response) => {
  Mustache.escape = (value) => value;
  let pipedResponseHeader = header;
  Mustache.tags = ['{', '}'];

  try {
    pipedResponseHeader = Mustache.render(header ?? '', response);
  } catch (error) {
    console.error('Error piping response header: ', error);
  }

  return pipedResponseHeader;
};

export const createControlForType = (type) => elements[type];

export function getCountriesList() {
  return [
    { name: 'Afghanistan', code: 'AF' },
    { name: 'Åland Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'Andorra', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia, Plurinational State of', code: 'BO' },
    { name: 'Bonaire, Sint Eustatius and Saba', code: 'BQ' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Canada', code: 'CA' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, the Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: "Côte d'Ivoire", code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Curaçao', code: 'CW' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'France', code: 'FR' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Germany', code: 'DE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and McDonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Italy', code: 'IT' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: "Korea, Democratic People's Republic of", code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: "Lao People's Democratic Republic", code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, the Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montenegro', code: 'ME' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestine, State of', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Réunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'Rwanda', code: 'RW' },
    { name: 'Saint Barthélemy', code: 'BL' },
    { name: 'Saint Helena, Ascension and Tristan da Cunha', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Martin (French part)', code: 'MF' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia', code: 'RS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Sint Maarten (Dutch part)', code: 'SX' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'South Sudan', code: 'SS' },
    { name: 'Spain', code: 'ES' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan, Province of China', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United States', code: 'US' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela, Bolivarian Republic of', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' },
  ];
}

function amendTableProps(ctrl) {
  const fields = ctrl.props.column_types;
  const tableProps = ctrl.table_props;
  for (let i = 0; i < tableProps.length; i += 1) {
    const fieldProp = tableProps[i];
    const arr = Object.keys(fieldProp);
    if (!fields[i]) {
      break;
    }
    const bCtrl = createControlForType(fields[i]);
    const bArr = Object.keys(bCtrl);
    for (let p = 0; p < arr.length; p += 1) {
      const attr = arr[p];
      if (bArr.indexOf(attr) === -1) {
        delete fieldProp[attr];
      } else if (fieldProp[attr] === null) {
        fieldProp[attr] = bCtrl[attr];
        if (typeof fieldProp[attr] === 'string') fieldProp[attr] = '';
      }
    }
    // propsObj[i] = fieldProp
  }
  // ctrl.table_props = propsObj
  return ctrl;
}

export function formAmendProps(form) {
  for (let i = 0; i < form.pages.length; i += 1) {
    for (let j = 0; j < form.pages[i].controls.length; j += 1) {
      let ctrl = form.pages[i].controls[j];
      const arr = Object.keys(ctrl.props || {});
      const bCtrl = createControlForType(ctrl.type);
      const bArr = Object.keys(bCtrl || {});
      for (let p = 0; p < arr.length; p += 1) {
        if (bArr.indexOf(arr[p]) === -1) {
          delete ctrl.props[arr[p]];
        } else if (ctrl.props[arr[p]] === null) {
          ctrl.props[arr[p]] = bCtrl[arr[p]];
          if (typeof ctrl.props[arr[p]] === 'string') ctrl.props[arr[p]] = '';
        }
      }
      for (let q = 0; q < bArr.length; q += 1) {
        if (arr.indexOf(bArr[q]) === -1) {
          ctrl.props[bArr[q]] = bCtrl[bArr[q]];
        }
      }

      if (ctrl.props.options) {
        ctrl.props.options = ctrl.props.options.reduce((a, b) => {
          if (a.indexOf(b) < 0) a.push(b);
          return a;
        }, []);
      }
      if (ctrl.type === 'inventory_field') {
        const props = cloneDeep(ctrl.props);
        const products = ctrl.props.inventory_products.map((product) => {
          return {
            ...product,
            payment_currency: product.payment_currency || props.currency,
            inventory_id: Number(ctrl.internal_id),
          };
        });
        props.inventory_products = products;
        ctrl.props = props;
      }

      if (ctrl.type === 'table_field') {
        ctrl = amendTableProps(ctrl);
      }
    }
  }
  return form;
}

export const formAmendForm = (form) => {
  let date;
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  if (form.definition && form.definition.pages !== null) {
    form.definition = formAmendProps(form.definition);
  }
  if (form.deadline) {
    date = new Date(`${form.deadline}T00:00:00`);
    form.deadline = `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  }
  if (form.submission_start_date) {
    form.submission_start_date = `${form.submission_start_date}.000Z`;
  }
  if (form.options && form.options.edit_deadline) {
    date = new Date(form.options.edit_deadline);
    form.options.edit_deadline = `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  }
  if (form.css_template && form.css_template) {
    form.css_template_key = form.css_template.key;
  }

  return form;
};

export function newIdentifier() {
  let candidateId = Date.now();
  while (candidateId.toString() in internalIdentifiers || candidateId.toString() in displayIdentifiers) {
    candidateId += 1;
  }
  candidateId = candidateId.toString();
  internalIdentifiers[candidateId] = true;
  displayIdentifiers[candidateId] = true;
  return candidateId;
}

let countryList = null;
const addPhoneCodesForCtrl = (ctrl) => {
  if (!countryList) {
    countryList = getCountriesList();
  }

  if (!ctrl.phoneCodes) {
    ctrl.phoneCodes = [];
    // for (let i = 0; i < countryList.length; i += 1) {
    //   const ccode = PhoneNumber.getCountryCodeForRegionCode(countryList[i].code);
    //   if (ccode) {
    //     ctrl.phoneCodes.push({
    //       code: countryList[i].code,
    //       name: `${countryList[i].name}, ${countryList[i].code} (+${ccode})`,
    //       ticked: ctrl.props.hasOwnProperty('phone_valid_codes')
    //         ? ctrl.props.phone_valid_codes.indexOf(countryList[i].code) !== -1
    //         : false,
    //     });
    //   }
    // }
  }
};

export const prepareForm = (definition, originType) => {
  if (definition && definition.pages !== null) {
    const form = definition;

    for (let p = 0; p < form.pages.length; p += 1) {
      if (!form.pages[p].internal_id) {
        form.pages[p].internal_id = newIdentifier();
      }
      for (let c = 0; c < form.pages[p].controls.length; c += 1) {
        const ctrl = form.pages[p].controls[c];

        if (originType && originType === OriginType.TEMPLATE) {
          ctrl.internal_id = ctrl.internal_id || newIdentifier();
          ctrl.display_id = ctrl.display_id || ctrl.internal_id;
        }
        if (ctrl.props.hasOwnProperty('phone_valid_codes')) {
          addPhoneCodesForCtrl(ctrl);
        }
        if (ctrl.props.hasOwnProperty('phone_default_code')) {
          ctrl.props.preferred_phone_codes = ['US']; // ctrl.props['phone_default_code']
        }
        if (ctrl.type === 'stripe') {
          if (!Array.isArray(ctrl.props.metadata)) {
            ctrl.props.metadata = [{ key: '', value: '' }];
          }
          if (ctrl.props.metadata.length === 0) {
            ctrl.props.metadata.push({ key: '', value: '' });
          }
        }
        const { internal_id } = ctrl;
        internalIdentifiers[internal_id] = ctrl;
        ctrl._validationError = '';
      }
    }

    return true;
  }
  return false;
};

export function handleAddRowControls(form, addRowControls) {
  for (let i = 0; i < form.pages.length; i += 1) {
    for (let j = form.pages[i].controls.length - 1; j >= 0; j -= 1) {
      if (form.pages[i].controls[j].is_row) {
        addRowControls[form.pages[i].controls[j].internal_id] = form.pages[i].controls[j];
        form.pages[i].controls.splice(j, 1);
      }
    }
  }
}

export const page = () => {
  return {
    controls: [],
  };
};

export const form = {
  name: '',
  pages: [page],
  rules: [],
  calculations: [],
};

export function getImageDimensions(file) {
  return new Promise(function (resolved) {
    const i = new Image();
    i.onload = function () {
      resolved({ w: i.naturalWidth || i.width, h: i.naturalHeight || i.height });
    };
    i.src = file;
  });
}

export function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }
  // separate out the mime component
  // var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], { type: 'image/png' });
}

export const getControlLabelText = (ctrl) => {
  if (ctrl === ControlType.TEXT_INPUT) {
    return 'Short Text';
  }
  if (ctrl === ControlType.NUMBER) {
    return 'Number';
  }
  if (ctrl === ControlType.EMAIL) {
    return 'Email';
  }
  if (ctrl === ControlType.WEBSITE) {
    return 'Website';
  }
  if (ctrl === ControlType.LABELED_INPUT) {
    return 'Labeled Text';
  }
  if (ctrl === ControlType.TEXT_AREA) {
    return 'Long Text';
  }
  if (ctrl === ControlType.DATETIME) {
    return 'Date & Time';
  }
  if (ctrl === ControlType.PHONE) {
    return 'Phone';
  }
  if (ctrl === ControlType.SIGNATURE) {
    return 'Signature';
  }
  if (ctrl === ControlType.TABLE_FIELD) {
    return 'Table';
  }
  if (ctrl === ControlType.SELECT_BASIC) {
    return 'Basic Select';
  }
  if (ctrl === ControlType.SELECT_MULTIPLE) {
    return 'Multiple Select';
  }
  if (ctrl === ControlType.CHECKBOXES) {
    return 'Checkboxes';
  }
  if (ctrl === ControlType.RADIO_BUTTONS) {
    return 'Radio';
  }
  if (ctrl === ControlType.IMAGE_CHOICE) {
    return 'Image Choice';
  }
  if (ctrl === ControlType.STAR_RATING) {
    return 'Star';
  }
  if (ctrl === ControlType.HEART_RATING) {
    return 'Heart';
  }
  if (ctrl === ControlType.SCALE_RATING) {
    return 'Scale';
  }
  if (ctrl === ControlType.MATRIX_RATING) {
    return 'Matrix';
  }
  if (ctrl === ControlType.SMILEY_RATING) {
    return 'Smiley';
  }
  if (ctrl === ControlType.DESCRIPTION) {
    return 'Description';
  }
  if (ctrl === ControlType.MEDIA_HEADER) {
    return 'Section Header';
  }
  if (ctrl === ControlType.MEDIA_IMAGE) {
    return 'Add Image';
  }
  if (ctrl === ControlType.EMBED_FIELD) {
    return 'Embed Video';
  }
  if (ctrl === ControlType.ROW) {
    return 'Add Row';
  }
  if (ctrl === ControlType.FILE_UPLOAD) {
    return 'File Upload';
  }
  if (ctrl === ControlType.PAYPAL) {
    return 'Paypal';
  }
  if (ctrl === ControlType.STRIPE) {
    return 'Stripe';
  }
  if (ctrl === ControlType.FLUTTERWAVE) {
    return 'Flutterwave';
  }
  if (ctrl === ControlType.PAYSTACK) {
    return 'Paystack';
  }
  if (ctrl === ControlType.LOOKUP) {
    return 'Lookup';
  }
  if (ctrl === ControlType.DURATION) {
    return 'Duration';
  }
  if (ctrl === ControlType.COUNTRY) {
    return 'Country';
  }
  if (ctrl === ControlType.ADDRESS) {
    return 'Address';
  }
};

export const defaultIntroPageButtonColor = '00A0C6';

export const defaultTimerOptions = {
  timer_purpose: '',
  timer_description: '',
  timer_countdown_to: '',
  timer_finish_do: 'do not submit',
  timer: {
    HH: 0,
    MM: 0,
    SS: 0,
  },
  timer_display: 'minimal',
  timer_position: 'top',
  timer_unique_ids: {
    filename: '',
    values: [],
  },
};

export const defaultIntroDetails = {
  intro_message: '',
  intro_alignment: 'center',
  intro_direction: 'ltr',
  intro_page_button_color: '00afbf',
  intro_page_button_text: '',
};

export const defaultSingleClosingPageDetails = {
  final_message: '',
  post_submission_alignment: 'center',
  post_submission_direction: 'ltr',
  show_print_response: false,
  another_response_link: false,
  after_redirect_to: '',
};

export const defaultClosingPages = [
  {
    id: 'default',
    title: 'Default',
    priority: 0,
    ...defaultSingleClosingPageDetails
  },
];

export function generateBuilderForm(loadedForm) {
  const bareForm = cloneDeep(loadedForm);

  const {
    name,
    description,
    closing_pages,
    intro_message,
    show_field_ids,
    intro_alignment,
    intro_direction,
    intro_page_button_text,
    intro_page_button_color,
    submission_button_background,
    definition: { calculations, rules, pages },
    options: { enable_timer, timer_options, enable_intro_page, enable_closing_page, enable_esignature } = {},
  } = bareForm;

  const identifiers = {};
  const pageIds = [];
  const formPages = [];
  const pagesName = [];
  const pagesIdentifiers = [];
  const oldInternalIdentifiers = {};
  const addRowCtrls = {};

  for (let i = 0; i < pages.length; i += 1) {
    const pageControls = pages[i].controls;
    identifiers[pages[i].internal_id] = true;
    pagesIdentifiers.push(pages[i].internal_id);
    pagesName.push(pages[i].name || 'default');
    const newPageIds = [];
    const newPageControls = {};
    for (let j = 0; j < pageControls.length; j += 1) {
      oldInternalIdentifiers[pageControls[j].internal_id] = pageControls[j];
      const control = pageControls[j];
      const controlId = control.internal_id;
      identifiers[controlId] = true;
      newPageIds.push(controlId);
      newPageControls[controlId] = control;
      if (control.is_row) addRowCtrls[control.internal_id] = control;
    }
    pageIds.push(newPageIds);
    formPages.push(newPageControls);
  }

  const newRules = cloneDeep(rules);
  for (const rule of newRules ?? []) {
    for (const trigger of rule?.triggers ?? []) {
      const triggeringCtrl = oldInternalIdentifiers[trigger.id];

      if (triggeringCtrl) {
        const isDateTime = triggeringCtrl.type === ControlType.DATETIME;

        if (isDateTime) {
          const { type, date_format, time_format, separator, mode } = triggeringCtrl.props;

          if (type === DateTimeType.DATE || type === DateTimeType.DATETIME) {
            trigger.timeFormat = time_format;
            trigger.dateFormat = date_format;
            trigger.separator = separator;
          } else {
            trigger.timeFormat = time_format;
          }
        }
      }
    }
  }

  const builderForm = {
    name,
    pageIds,
    pagesName,
    identifiers,
    description,
    calculations,
    rules: newRules,
    pages: formPages,
    pagesIdentifiers,
  };

  const introDetails = {
    intro_message,
    intro_alignment,
    intro_direction,
    intro_page_button_text: intro_page_button_text,
    intro_page_button_color: intro_page_button_color || submission_button_background,
  };

  const closingPages = closing_pages ? Object.values(closing_pages).sort((a, b) => a.priority - b.priority) : defaultClosingPages;
  
  return {
    builderForm,
    addRowCtrls,
    introDetails,
    closingPages,
    oldInternalIdentifiers,
    showFieldIds: show_field_ids,
    enableTimer: enable_timer || false,
    enableIntroPage: enable_intro_page || false,
    enableESignature: enable_esignature || false,
    enableClosingPage: enable_closing_page || false,
    timerOptions: timer_options || defaultTimerOptions,
  };
}

export function isValidCalculationControl(ctrl) {
  const fields = ['labeled_input', 'text_input', 'short_text', 'prepended_text'];
  if (fields.includes(ctrl.type) && ctrl.props.type !== 2) {
    return false;
  }
  return fplsConstants.CALCULATION_CONTROL_LIST.indexOf(ctrl.type) !== -1;
}

export function isValidCalculationResultControl(ctrl) {
  return fplsConstants.CALCULATION_CONTROL_RESULT_LIST.indexOf(ctrl.type) !== -1;
}

export function isValidStripeMetadataControl(ctrl) {
  if (!ctrl) return false;
  return fplsConstants.STRIPE_METADATA_CONTROL_LIST.indexOf(ctrl.type) > -1;
}

export const doCreateIdentifier = (identifiers) => {
  let candidateId = Date.now();
  if (Object.keys(identifiers).length > 0) {
    while (candidateId.toString() in identifiers) {
      candidateId += 1;
    }
  }
  candidateId = candidateId.toString();
  return candidateId;
};

// Only used for creating new result field for calculation.
export const doAssignControlIdentifiers = (control, identifiers) => {
  const internalId = doCreateIdentifier(identifiers);
  let newControl = cloneDeep(control);
  newControl.internal_id = internalId;
  newControl.display_id = internalId;
  newControl.table_props = [];
  newControl.value = null;
  newControl._validationError = '';
  // delete newControl.props.type;
  return newControl;
};

export const assignActivePage = (pages, index) => {
  if (pages[index - 1]) {
    return index - 1;
  }
  return 0;
};

export function ctrlRuleLabel(pageNumber, ctrl, showID) {
  let label = pageNumber !== null ? `Page ${pageNumber + 1} : ` : '';

  switch (ctrl.type) {
    case ControlType.DESCRIPTION:
      label += 'description';
      break;
    case ControlType.MEDIA_HEADER:
      label += 'section header';
      break;
    case ControlType.EMBED_FIELD:
      label += 'video';
      break;
    case ControlType.MEDIA_IMAGE:
      label += 'image';
      break;
    case ControlType.ROW:
      label += 'Row';
      break;
    case 'page':
      label = ctrl.props.label;
      break;
    default:
      label += ctrl.props.label;
  }

  if (showID) {
    label += ` :: ${ctrl.display_id}`;
  }

  return label;
}

export const getConditionTypes = (ctrlType) => {
  switch (ctrlType) {
    case ControlType.HEART_RATING:
    case ControlType.MATRIX_RATING:
    case ControlType.SCALE_RATING:
    case ControlType.SMILEY_RATING:
    case ControlType.STAR_RATING:
    case ControlType.IMAGE_CHOICE:
      return [
        { text: 'is empty', value: 'empty', key: 'empty' },
        { text: 'is not empty', value: 'not_empty', key: 'not_empty' },
        { text: 'equals', value: 'equal', equal: 'empty' },
        { text: "doesn't equal", value: 'not_equal', key: 'not_equal' },
      ];
    case ControlType.FILE_UPLOAD:
    case ControlType.SIGNATURE:
      return [
        { text: 'is empty', value: 'empty', key: 'empty' },
        { text: 'is not empty', value: 'not_empty', key: 'not_empty' },
      ];
    case ControlType.NUMBER:
      return [
        { text: 'is empty', value: 'empty', key: 'empty' },
        { text: 'is not empty', value: 'not_empty', key: 'not_empty' },
        { text: 'equals', value: 'equal', key: 'equal' },
        { text: "doesn't equal", value: 'not_equal', key: 'not_equal' },
        { text: 'contains', value: 'contain', key: 'contain' },
        { text: 'does not contain', value: 'not_contain', key: 'not_contain' },
        { text: 'is greater than', value: 'greater_than', key: 'greater_than' },
        { text: 'is greater than or equal to', value: 'greater_than_equal', key: 'greater_than_equal' },
        { text: 'is less than', value: 'less_than', key: 'less_than' },
        { text: 'is less than or equal to', value: 'less_than_equal', key: 'less_than_equal' },
        { text: 'is between', value: 'between', key: 'between' },
      ];
    case ControlType.DATETIME:
      return [
        { text: 'is empty', value: 'empty', key: 'empty' },
        { text: 'is not empty', value: 'not_empty', key: 'not_empty' },
        { text: 'equals', value: 'equal', key: 'equal' },
        { text: "doesn't equal", value: 'not_equal', key: 'not_equal' },
        { text: 'contains', value: 'contain', key: 'contain' },
        { text: 'does not contain', value: 'not_contain', key: 'not_contain' },
        { text: 'is later than', value: 'greater_than', key: 'greater_than' },
        { text: 'is later than or equal to', value: 'greater_than_equal', key: 'greater_than_equal' },
        { text: 'is earlier than', value: 'less_than', key: 'less_than' },
        { text: 'is earlier than or equal to', value: 'less_than_equal', key: 'less_than_equal' },
      ];
    default:
      return [
        { text: 'is empty', value: 'empty', key: 'empty' },
        { text: 'is not empty', value: 'not_empty', key: 'not_empty' },
        { text: 'equals', value: 'equal', key: 'equal' },
        { text: "doesn't equal", value: 'not_equal', key: 'not_equal' },
        { text: 'contains', value: 'contain', key: 'contain' },
        { text: 'does not contain', value: 'not_contain', key: 'not_contain' },
      ];
  }
};

export function allowedConditionTypes() {
  const emptyConditions = ['empty', 'not_empty'];
  const equalConditions = ['equal', 'not_equal'];
  const containConditions = ['contain', 'not_contain'];
  const emptyAndEqualConditions = [...emptyConditions, ...equalConditions];
  const greaterOrLessConditions = ['greater_than', 'greater_than_equal', 'less_than', 'less_than_equal'];
  const allConditions = [...emptyAndEqualConditions, ...containConditions, ...greaterOrLessConditions];

  const acTypes = {};
  acTypes[ControlType.APPENDED_TEXT] = allConditions;
  acTypes[ControlType.CHECKBOXES] = allConditions;
  acTypes[ControlType.EMAIL] = allConditions;
  acTypes[ControlType.WEBSITE] = allConditions;
  acTypes[ControlType.INLINE_CHECKBOXES] = allConditions;
  acTypes[ControlType.INLINE_RADIOS] = allConditions;
  acTypes[ControlType.LABELED_INPUT] = [...allConditions, 'between'];
  acTypes[ControlType.NUMBER] = [...allConditions, 'between'];
  acTypes[ControlType.PREPENDED_TEXT] = allConditions;
  acTypes[ControlType.RADIO_BUTTONS] = allConditions;
  acTypes[ControlType.SELECT_BASIC] = allConditions;
  acTypes[ControlType.SELECT_MULTIPLE] = allConditions;
  acTypes[ControlType.TEXT_INPUT] = allConditions;
  acTypes[ControlType.SHORT_TEXT] = [...allConditions, 'between'];
  acTypes[ControlType.DATETIME] = allConditions;
  acTypes[ControlType.PHONE] = [...emptyAndEqualConditions, ...containConditions];
  acTypes[ControlType.COUNTRY] = [...emptyAndEqualConditions, ...containConditions];
  // Rating fields
  acTypes[ControlType.HEART_RATING] = emptyAndEqualConditions;
  acTypes[ControlType.MATRIX_RATING] = emptyAndEqualConditions;
  acTypes[ControlType.SCALE_RATING] = emptyAndEqualConditions;
  acTypes[ControlType.SMILEY_RATING] = emptyAndEqualConditions;
  acTypes[ControlType.STAR_RATING] = emptyAndEqualConditions;
  acTypes[ControlType.IMAGE_CHOICE] = emptyAndEqualConditions;
  // File & signature
  acTypes[ControlType.FILE_UPLOAD] = emptyConditions;
  acTypes[ControlType.SIGNATURE] = emptyConditions;
  // add lookup and unit

  return acTypes;
}

export const adjustConditionsForDateMode = (mode, disableYearEffect = false) => {
  const valuesToRemove = () => {
    return {
      single: disableYearEffect ? [] : ['contain', 'not_contain'],
      multiple: ['greater_than', 'greater_than_equal', 'less_than', 'less_than_equal'],
      range: ['contain', 'not_contain', 'greater_than', 'greater_than_equal', 'less_than', 'less_than_equal'],
    }[mode];
  };
  return valuesToRemove() || [];
};

export function matrixAns(mat, row, col) {
  return `${mat.props.row_headers[row]}: ${mat.props.column_headers[col]}`;
}

export const createTableProps = (columnHeaders) => {
  const tableProps = [];
  columnHeaders.forEach((header) => {
    tableProps.push(createControlForType(header));
  });
  return tableProps;
};

const FILE_FIELD_RENAME_LIST = {
  [ControlType.TEXT_INPUT]: true,
  [ControlType.SHORT_TEXT]: true,
  [ControlType.APPENDED_TEXT]: true,
  [ControlType.PREPENDED_TEXT]: true,
  [ControlType.LABELED_INPUT]: true,
  [ControlType.EMAIL]: true,
  [ControlType.RADIO]: true,
  [ControlType.RADIO_BUTTONS]: true,
  [ControlType.INLINE_RADIOS]: true,
  [ControlType.SELECT_BASIC]: true,
};

export const isSimpleTextControl = (ctrl) => {
  return FILE_FIELD_RENAME_LIST[ctrl.type];
};

export const isEmailControl = (ctrl) => {
  const email = ctrl.type === ControlType.EMAIL;
  const labeledEmail = (ctrl.props.type && ctrl.props.type === InputType.EMAIL) || false;
  const lookupEmail = ctrl.props.lookup_type && ctrl.props.field_type === 'email';
  return email || labeledEmail || lookupEmail;
};

export const AUTOFILL_LOOKUP_ALLOWED_FIELDS = {
  [ControlType.TEXT_INPUT]: true,
  [ControlType.SHORT_TEXT]: true,
  [ControlType.NUMBER]: true,
  [ControlType.EMAIL]: true,
  [ControlType.WEBSITE]: true,
  [ControlType.COUNTRY]: true,
  [ControlType.PHONE]: true,
  [ControlType.DATETIME]: true,
  [ControlType.LABELED_INPUT]: true,
  [ControlType.TEXT_AREA]: true,
  [ControlType.ADDRESS]: true,
  [ControlType.SELECT_BASIC]: true,
  [ControlType.SELECT_MULTIPLE]: true,
  [ControlType.RADIO]: true,
  [ControlType.RADIO_BUTTONS]: true,
  [ControlType.INLINE_RADIOS]: true,
  [ControlType.CHECKBOX]: true,
  [ControlType.CHECKBOXES]: true,
  [ControlType.INLINE_CHECKBOXES]: true,
  [ControlType.STAR_RATING]: true,
  [ControlType.HEART_RATING]: true,
  [ControlType.SCALE_RATING]: true,
  [ControlType.SMILEY_RATING]: true,
};

export const ctrlErrors = {
  description: 'Invalid characters included',
  number_input: 'Default value for number field ' + 'must be a number. No other characters allowed.',
  text_input: 'Default value for number field ' + 'must be a number. No other characters allowed.',
  labeled_input: 'Default value for number field ' + 'must be a number. No other characters allowed.',
  prepended_text: 'Default value for number field ' + 'must be a number. No other characters allowed.',
  appended_text: 'Default value for number field ' + 'must be a number. No other characters allowed.',
  min_max: 'Minimum length cannot be greater than maximum length',
  min_selection: 'Minimum selections cannot be greater than the total number of options available',
  max_selection: 'Maximum selections cannot be greater than the total number of options available',
  minselection_max: 'Minimum selections cannot be greater than maximum selections',
  no_options: 'Please add one or more options',
  optionsZero: 'Please input option values',
  optionsTwo: 'Number of options must not be greater than 2',
  max_word: 'Minimum word length cannot be greater than maximum word length',
  valid_phone: 'At least one valid phone code must be selected',
  empty_url: "The URL field can't be empty. Please include a valid URL.",
  invalid_url: 'Invalid URL, please check',
  unapproved_url: "This URL isn't allowed. Please see above for supported domains",
  column_headermax: 'The number of Column headers given must not be more than fifteen (15)',
  row_headermax: 'The number of Row headers given must not be more than fifteen (15).',
  blank_matrix_headers: 'Row/column header values cannot be blank. Please check to remove whitespaces and/or add a value',
  similar_matrix_headers: 'Row/column header values cannot be similar. Please check to remove similar values',
  imageOptions: 'Please add atleast one image option',
  imagelabel_empty: 'Please provide labels for all images',
  amount_empty: 'Amount must be greater than zero (0)',
  payment_required: 'cannot be set as a `required` field until',
  payment_credential: ' credentials are added.',
  nodecimal_support: 'Decimal amounts are not supported for this currency: ',
  paypal_err: 'in Paypal. Passing a decimal amount will throw an error when payment is in progress.',
  nocol_name: 'A column name is required for all columns',
  row_empty: 'Number of rows to be displayed by default should be at least one',
  row_exceeded: 'Number of rows to be displayed by default can not be more than fifty',
  resrow_empty: 'Maximum number of rows that can be added by respondents should be at least one',
  resrow_exceeded: 'Maximum number of rows that can be added by respondents should be at most fifty',
  source_field: 'Fields to map must be unique',
  min_date: 'Minimum date cannot be greater than maximum date',
  min_time: 'Minimum time cannot be greater than maximum time',
  unique_field: 'Fields to map must be unique',
  unequal_source_to_destination: 'Source fields must map to exact count of destination fields',
  no_rename_internalId: 'Please select a field to use for renaming',
  minmax_count: 'Minimum number count cannot be greater than maximum number count',
  minmax_acceptable: 'Minimum acceptable value cannot be greater than maximum acceptable value',
  min_acceptable_equals_max: 'Minimum acceptable value cannot be equal to maximum acceptable value',
  min_acceptable_less_min_count: 'Minimum acceptable value cannot have characters less than mininum number count',
  max_acceptable_less_min_count: 'Maximum acceptable value cannot have characters less than mininum number count',
  min_acceptable_greater_max_count: 'Minimum acceptable value cannot have characters greater than maximum number count',
  max_acceptable_greater_max_count: 'Maximum acceptable value cannot have characters greater than maximum number count',
  payment_merchant_is_required: 'Inventory payment method is required',
};

export const errorMessages = {
  fetchForm: {
    unknown: `An error has occurred when attempting to retrieve this form. Please refresh & try again. You may also send an email to support@formpl.us if this persists`,
    notFound: 'Requested form could not be found.'
  }
};

export function checkWideForm(newForm, metaData) {
  const formJ = newForm;
  const { pages } = formJ;
  const WIDEFORM = 'wide_form';
  const wideFields = [ControlType.TABLE_FIELD, ControlType.MATRIX_RATING];

  pages.forEach((pageJ, index) => {
    pageJ.controls.forEach((ctrl) => {
      const ctrlType = ctrl.type;
      const validLongField = wideFields.includes(ctrlType);
      if (validLongField) {
        metaData[WIDEFORM] = true;
      }
    });
  });
  return { formJ, metaData };
}

function replaceNull(item) {
  return item ?? 1;
}

export const ammendBuilderForm = (builderForm) => {
  const formObj = cloneDeep(builderForm);
  const { pagesIdentifiers, pageIds, pagesName } = formObj;
  const newForm = {};
  newForm.name = formObj.name;
  newForm.calculations = formObj.calculations;
  newForm.rules = formObj.rules;
  let pageId;
  let pageName;

  for (let i = 0; i < formObj.pages.length; i += 1) {
    pageId = pagesIdentifiers[i];
    pageName = pagesName[i];
    const controls = [];
    pageIds[i].forEach((id, idx) => {
      const fieldId = pageIds[i][idx];
      const ctrl = formObj.pages[i][Number(fieldId)];
      if (ctrl.type === 'select_multiple') {
        // Fix for value of the select_multiple being null if no item is included
        ctrl.value = '';
      }
      if (ctrl && ctrl.type === 'table_field' && ctrl.table_props) {
        for (let tpi = 0; tpi < ctrl.table_props.length; tpi += 1) {
          const tableProp = ctrl.table_props[tpi];
          const columnHeader = ctrl.props.column_headers[tpi];
          // cleanFormInputFromXSS(tableProp);
          ctrl.props.column_headers[tpi] = htmlToPlainText(columnHeader);
        }
      }
      if (ctrl && ctrl.props.weights) {
        const cleanedWeights = ctrl.props.weights.map(replaceNull);
        ctrl.props.weights = cleanedWeights;
      }
      if (ctrl && ctrl.props.options) {
        ctrl.props.options = ctrl.props.options.reduce((a, b) => {
          if (a.indexOf(b) < 0) a.push(b);
          return a;
        }, []);
      }
      if (ctrl && ctrl.props.phone_default_code && ctrl.props.phone_default_code != null) {
        ctrl.props.preferred_phone_codes = [ctrl.props.phone_default_code];
      }

      if (ctrl && ctrl.props.hidden && ctrl.props.required) {
        ctrl.props.required = false;
      }

      if (ctrl && ctrl.props.readonly && ctrl.props.required) {
        ctrl.props.required = false;
      }

      if (ctrl && ctrl.props && ctrl.props.list_products) {
        if (ctrl.props.user_specify) {
          ctrl.props.user_specify = false;
        }
      }

      if (ctrl && ctrl.type === 'inventory_field') {
        const {
          props: { inventory_products, currency },
          internal_id,
        } = ctrl;

        ctrl.props.inventory_products = inventory_products.map((product) => ({
          ...product,
          payment_currency: product.payment_currency || currency,
          inventory_id: Number(internal_id),
        }));
      }

      ctrl._validationError = '';
      controls.push(ctrl);
    });
    formObj.pages[i] = {
      internal_id: pageId,
      name: pageName,
      controls,
    };
  }
  newForm.pages = formObj.pages;

  return newForm;
};

export function pageReorderControl(formPage, addRowControls) {
  const newOrder = [];
  let rowCtrl;
  for (let g = 0; g < formPage.controls.length; g += 1) {
    if (formPage.controls[g].type === 'add_row') {
      rowCtrl = formPage.controls[g];
      newOrder.push(rowCtrl);
      for (let h = 0; h < rowCtrl.props.controls.length; h += 1) {
        const ctrl = addRowControls[rowCtrl.props.controls[h]];
        if (ctrl) newOrder.push(ctrl);
      }
    } else if (!formPage.controls[g].is_row) {
      newOrder.push(formPage.controls[g]);
    }
  }
  return newOrder;
}

export function getComponentLabelText(field) {
  if (field.name === 'label') {
    return 'Enter Label';
  }
  if (field.name === 'subtext') {
    return 'Help Text';
  }
  if (field.name === 'placeholder') {
    return 'Placeholder Text';
  }
  if (field.name === 'default') {
    return 'Set Default Value';
  }
  if (field.name === 'label_placeholder') {
    return 'Type in A Field Label (Question)';
  }
  if (field.name === 'subtext_placeholder') {
    return 'Click to edit help text';
  }
  if (field.name === 'placeholder_placeholder') {
    return 'Click to edit placeholder text';
  }
  if (field.name === 'default_placeholder') {
    return 'Set default value for this field';
  }
  if (field.name === 'phone_codes_limit') {
    return 'Limit to selected countries';
  }
  if (field.name === 'file_extensions') {
    return 'Allowed file extensions separated by a space or comma e.g.: pdf, png, doc';
  }
  if (field.name === 'file_categories') {
    return 'Use a combination of categories and extensions (below) to limit what files users can upload to your form.';
  }
  if (field.name === 'phone_default_code') {
    return 'Default phone code';
  }
  if (field.name === 'phone_valid_codes') {
    return 'Valid phone codes';
  }
  if (field.name === 'file_extensions') {
    return 'Allowed file extensions';
  }
  if (field.name === 'max_word_length') {
    return 'Maximum word count';
  }
  if (field.name === 'min_word_length') {
    return 'Minimum word count';
  }
  if (field.name === 'prepended_text') {
    return 'Enter prepended label';
  }
  if (field.name === 'appended_text') {
    return 'Enter appended label';
  }
  if (field.name === 'max_length' || field.name === 'max_count') {
    return 'Maximum character count';
  }
  if (field.name === 'min_length' || field.name === 'min_count') {
    return 'Minimum character count';
  }
  if (field.name === 'max_acceptable') {
    return 'Maximum acceptable value';
  }
  if (field.name === 'min_acceptable') {
    return 'Minimum acceptable value';
  }
  if (field.name === 'max_selections') {
    return 'Maximum selections allowed';
  }
  if (field.name === 'min_selections') {
    return 'Minimum selections allowed';
  }
  if (field.name === 'required') {
    return 'Required Field?';
  }
  if (field.name === 'inline') {
    return 'Display options inline?';
  }
  if (field.name === 'other') {
    return 'Add "Others" option?';
  }
  if (field.name === 'right') {
    return 'Show appended label?';
  }
  if (field.name === 'left') {
    return 'Show prepended label?';
  }
  if (field.name === 'popup_title') {
    return 'Payment Box Title';
  }
  if (field.name === 'user_specify') {
    return 'Allow user specify the amount to be paid?';
  }
  if (field.name === 'popup_description') {
    return 'Payment Box Description';
  }
  if (field.name === 'pay_button_text') {
    return 'Payment Button Title';
  }
  if (field.name === 'payment_logo') {
    return 'Logo Url';
  }
  if (field.name === 'max_rows') {
    return 'Maximum number of rows that can be added by respondents';
  }
  if (field.name === 'min_rows') {
    return 'Number of rows to be displayed by default';
  }
  if (field.name === 'images') {
    return 'Image link';
  }
  if (field.name === 'shuffle_options') {
    return 'Shuffle options randomly?';
  }
  if (field.name === 'weights') {
    return 'Add a weight for this field';
  }
  if (field.name === 'hidden') {
    return 'Hide this field?';
  }
  if (field.name === 'option_values') {
    return 'Assign value to each option?';
  }
  if (field.name === 'sort_options') {
    return 'Arrange options alphabetically?';
  }
  if (field.name === 'column_calculation') {
    return 'Attach a calculation to this column field';
  }
  if (field.name === 'readonly') {
    return 'Make field read-only?';
  }
  if (field.name === 'past') {
    return 'Disable past dates?';
  }
  if (field.name === 'future') {
    return 'Disable future dates?';
  }
  if (field.name === 'now') {
    return "Use 'NOW' as the default date?";
  }
  if (field.name === 'disabled_dates') {
    return 'Disable specific dates?';
  }
  if (field.name === 'disabled_date_range') {
    return 'Disable dates within a range?';
  }
  if (field.name === 'list_products') {
    return 'List Stripe products on form?';
  }
  if (field.name === 'billing_address') {
    return 'Collect billing address from customers?';
  }
  if (field.name === 'save_card_stripe') {
    return 'Save card details on Stripe?';
  }
  if (field.name === 'modal_pay_button') {
    return 'Set payment button text.';
  }

  return field.name.split('_').join(' ');
}

export const allowedRowFields = [
  'text_input',
  'short_text',
  'labeled_input',
  'prepended_text',
  'email',
  'website',
  'text_area',
  'datetime',
  'phone',
  'select_basic',
  'checkboxes',
  'file_upload',
  'star_rating',
  'heart_rating',
  'scale_rating',
  'smiley_rating',
  'stripe',
  'flutterwave',
  'number_input',
  'select_multiple',
  'radio_buttons',
  'paypal',
  'paystack',
  'description',
  'media_image',
  'embed_field',
  'lookup',
  'country',
];

export const choiceFields = [
  // controls with props.options || props.weights || props.images
  ControlType.SELECT_BASIC,
  ControlType.SELECT_MULTIPLE,
  ControlType.RADIO_BUTTONS,
  ControlType.CHECKBOXES,
  ControlType.CHECKBOX,
  ControlType.RADIO,
  ControlType.INLINE_RADIOS,
  ControlType.INLINE_CHECKBOXES,
  ControlType.IMAGE_CHOICE,
  ControlType.RANKING,
];

export const textFieldsCanHaveType = [
  ControlType.TEXT_INPUT,
  ControlType.SHORT_TEXT,
  ControlType.LABELED_INPUT,
  ControlType.APPENDED_TEXT,
  ControlType.PREPENDED_TEXT,
]

export const textFieldCanHaveDefault = [
  // text fields for which default value can be set
  ControlType.EMAIL,
  ControlType.NUMBER,
  ControlType.WEBSITE,
  ControlType.COUNTRY,
  ControlType.TEXT_AREA,
  ControlType.TEXT_INPUT,
  ControlType.SHORT_TEXT,
  ControlType.LABELED_INPUT,
  ControlType.APPENDED_TEXT,
  ControlType.PREPENDED_TEXT,
];

export const basicInputTypeLookUpFields = [
  // lookup field types for which default value can be set
  ControlType.EMAIL,
  ControlType.TEXT_INPUT,
  ControlType.SHORT_TEXT,
  ControlType.NUMBER,
];

export const numberTypeProps = {
  unsignable: [
    'width',
    'height',
    'amount',
    'min_rows',
    'max_rows',
    'min_count',
    'max_count',
    'min_length',
    'max_length',
    'table_width',
    'min_selections',
    'max_selections',
    'min_word_length',
    'max_word_length',
  ],
  signable: ['min_acceptable', 'max_acceptable'],
};

const cleanPlaceholder = (placeholder) => {
  if (placeholder && placeholder.toLowerCase() === 'placeholder') return '';
  return placeholder;
};

export const calcVisiblePages = (pages, hiddenFields) => {
  if (!pages) return [];
  return visiblePages(pages, hiddenFields);
};

export const prepareFormForForm = (editableForm) => {
  const {
    definition: { pages, rules },
    closing_pages: closingPages = {},
  } = editableForm;

  // maps every internal_field id to boolean status telling if the field is visible
  const hiddenFields = {};

  // maps interal_field_id to the ctrl/page object
  const ctrlIndex = {};

  // maps triggering_field_ids to list of rules triggered by them
  const triggeringFields = {};

  // maps field IDs to list of rules acting them
  const actionFields = {};

  const tableColumnResult = {};
  const tableColumnCalculations = {};

  const paymentFields = PaymentTypes;
  let hasFileUploadField = false;
  let hasPaymentField = false;
  let hasSignatureField = false;

  // has a payment, file upload or signature field that is required
  let hasOfflineRestrictedRequiredField = false;

  if (rules.length) {
    for (let r = 0; r < rules.length; r += 1) {
      const rule = rules[r];
      if (rule.option) {
        rule.actions.forEach((action) => {
          !(action.id in actionFields) && (actionFields[action.id] = []);
          actionFields[action.id].push(rule);
        });
        rule.triggers.forEach((trigger) => {
          !(trigger.id in triggeringFields) && (triggeringFields[trigger.id] = []);
          triggeringFields[trigger.id].push(rule);
        });
      } else if (rule.triggering_field_id) {
        !(rule.triggering_field_id in triggeringFields) && (triggeringFields[rule.triggering_field_id] = []);
        triggeringFields[rule.triggering_field_id].push(rule);
      }
    }
  }

  for (let i = 0; i < pages.length; i += 1) {
    const page = pages[i];
    hiddenFields[page.internal_id] = false;
    ctrlIndex[page.internal_id] = {
      type: 'page',
      index: i,
      internal_id: page.internal_id,
    };
    for (let k = 0; k < page.controls.length; k += 1) {
      const control = page.controls[k];
      const { placeholder, columns, column_types } = control.props;
      if (
        (textFieldCanHaveDefault.includes(control.type) ||
          (ControlType.LOOKUP && basicInputTypeLookUpFields.includes(control.props.field_type))) &&
        control.props.default
      ) {
        if (control.type === ControlType.COUNTRY) {
          const countries = getCountriesList();
          const foundCountry = countries.find((c) => c.code === control.props.default);
          control.value = control.value || foundCountry?.name;
        } else {
          control.value = control.value || control.props.default;
        }
      }
      control.props.placeholder = cleanPlaceholder(placeholder);
      hiddenFields[control.internal_id] = false;
      ctrlIndex[control.internal_id] = control;
      if (control.type === ControlType.FILE_UPLOAD) hasFileUploadField = true;
      if (control.type === ControlType.SIGNATURE) hasSignatureField = true;
      if (paymentFields.includes(control.type)) hasPaymentField = true;
      if ((hasFileUploadField || hasSignatureField || hasPaymentField) && control.props.required) {
        hasOfflineRestrictedRequiredField = true;
      }
      if (control.type === 'table_field') {
        tableColumnResult[control.internal_id] = Array(columns);
        tableColumnCalculations[control.internal_id] = Array(columns);
        for (let col = 0; col < columns; col++) {
          tableColumnResult[control.internal_id][col] = null;
          tableColumnCalculations[control.internal_id][col] = null;
        }

        hasFileUploadField = hasFileUploadField || column_types.indexOf(ControlType.FILE_UPLOAD) > -1;
        hasSignatureField = hasSignatureField || column_types.indexOf(ControlType.SIGNATURE) > -1;

        if (!hasPaymentField) {
          for (const payment of paymentFields) {
            hasPaymentField = hasPaymentField || column_types.includes(payment);
          }
        }

        if (hasFileUploadField || hasSignatureField || hasPaymentField) {
          hasOfflineRestrictedRequiredField =
            hasOfflineRestrictedRequiredField ||
            control.table_props.some(
              (prop, index) => prop.required && OfflineRestrictedTypes.includes(column_types[index])
            );
        }
      }
    }
  }

  // Store closing pages identifiers for logic use
  Object.values(closingPages).forEach((page, index) => {
    if (page.title !== 'Default') {
      hiddenFields[page.id] = false;
      ctrlIndex[page.id] = {
        type: 'closing_page',
        internal_id: page.id,
        index,
      };
    }
  });

  // Store submit button identifiers for logic use
  hiddenFields[SUBMIT_BUTTON_ID] = false;
  ctrlIndex[SUBMIT_BUTTON_ID] = {
    internal_id: SUBMIT_BUTTON_ID,
    type: 'submit_button',
  };

  // Trigger all form rule actions for all pages on first time loading
  if (rules.length) {
    for (const { controls } of pages) {
      for (const ctrl of controls) {
        if (isTriggerField(triggeringFields, ctrl.internal_id)) {
          applyLogic(ctrl.internal_id, ctrlIndex, triggeringFields, actionFields, editableForm, hiddenFields);
        }
      }
    }
  }

  return {
    ctrlIndex,
    actionFields,
    hiddenFields,
    hasPaymentField,
    triggeringFields,
    tableColumnResult,
    hasSignatureField,
    hasFileUploadField,
    tableColumnCalculations,
    hasOfflineRestrictedRequiredField,
  };
};

export const setTableCtrlValueToNull = (ctrl) => {
  const ctrlVal = [];
  for (let m = 0; m < ctrl.props.min_rows; m++) {
    ctrlVal.push([]);
    for (let c = 0; c < ctrl.props.columns; c++) {
      ctrlVal[m][c] = null;
    }
  }
  return ctrlVal;
};

const { PLAN } = win;
export const planSupportField = (controlType) => controlType in PLAN.allowed_fields;

export const formHasControls = (formObj) => {
  const { pageIds } = formObj;
  for (let i = 0; i < pageIds.length; i += 1) {
    if (pageIds[i].length) return true;
  }
  return false;
};

export const trackSettings = (action, id) => {
  const formId = id || '_NEW_';
  const metadata = {
    form_url: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/form/${formId}`,
    plan_name: win.PLAN.name,
    form_id: formId,
  };

  window.Intercom('trackEvent', action, metadata);
};

export const sendFieldToIntercom = (type, id) => {
  const action = `added-${type}-field`;
  trackSettings(action, id);
};

export const defaultTextAlignmentOptions = [
  { value: 'center', text: 'Center' },
  { value: 'left', text: 'Left' },
  { value: 'right', text: 'Right' },
];

export const defaultTextDirectionOptions = [
  { value: 'ltr', text: 'Left to right' },
  { value: 'rtl', text: 'Right to left' },
];

export const countdownPurpose = [
  {
    description: 'Submits form automatically for each respondent once timer runs out',
    text: 'Quiz and surveys',
    value: 'quiz',
  },
  {
    description: 'Best used as a countdown for general event deadlines. Timer will run until the event ends',
    text: 'Events banner',
    value: 'event',
  },
];

export const countdownDisplay = [
  { description: 'Suitable for examination and quizzes etc', text: 'Minimal', value: 'minimal' },
  {
    description: 'Suitable for event countdowns',
    text: 'Banner',
    value: 'banner',
  },
];

export const countdownPosition = [
  {
    label: 'Top of form',
    value: 'top',
  },
  { label: 'Bottom of form', value: 'bottom' },
];

export const countdownEndAction = [
  {
    description: 'This submits the form automatically when the time elapses. Will not submit an empty form',
    text: 'Submit Responses Automatically',
    value: 'submit',
  },
  {
    description: 'This closes the form immediately the time elapses without submitting the form',
    text: 'Disable Form Submission',
    value: 'do not submit',
  },
];

export const closingPagesAsDict = (closingPages) => {
  return closingPages.reduce((acc, page) => {
    acc[`${page.id}`] = page;
    return acc;
  }, {});
};

export const convertToStorableClosingPages = (closingPages) => {
  const pagesWithPriority = closingPages.map((page, index) => ({
    ...page,
    priority: index,
  }));

  return closingPagesAsDict(pagesWithPriority);
};

export default {
  form,
  page,
  InputType,
  prepareForm,
  ControlType,
  ctrlDefaults,
  formAmendForm,
  dataURItoBlob,
  assignActivePage,
  getCountriesList,
  getImageDimensions,
  prepareFormForForm,
  sendFieldToIntercom,
  createControlForType,
  setTableCtrlValueToNull,
  allowedFilterConditionTypes,
};
